module.exports = __webpack_public_path__ + "img/Dantam Hair 05.687bf5aa.jpg";